import { IConfigValidation } from './inspection.interface'
import { ICreateInspectionCommon } from './vehicle.interface'

export interface IMachineryConfig {
  object: IConfigValidation
  color: IConfigValidation
  type: IConfigValidation
  date: IConfigValidation
}

export enum MachineryEnum {
  TRACTOR = 'tractor',
  COMBINE_HARVESTER = 'combine_harvester',
  SPRAYER = 'sprayer',
  SEEDER = 'seeder',
  FUMIGATOR = 'fumigator',
  BALER = 'baler',
  ROUND_BALER = 'round_baler',
  PAVER = 'paver',
  LEVELER = 'leveler',
  CRANE = 'crane',
  EXCAVATOR = 'excavator',
  CARTS = 'carts',
  GRADER = 'grader',
  LOADER = 'loader',
  SCRAPERS = 'scrapers',
  COMPACTING_MACHINE = 'compacting_machine',
  MACHINE_SOIL_TREATMENT = 'machine_soil_treatment',
  FORKLIFT = 'forklift',
  MOTOR_VEHICLE_WITH_COUPLING_DEVICE = 'motor_vehicle_with_coupling_device',
  FERTILIZER = 'fertilizer',
  BACKHOE = 'backhoe',
  BULLDOZER = 'bulldozer',
  COMPACTOR = 'compactor',
  HIDROGUA = 'hidrogua',
  TRENCHER = 'trencher',
  MIXER = 'mixer',
  HOPPER = 'hopper',
  MECHANICAL_SHOVEL = 'mechanical_shovel',
}

export interface IMachinery {
  type: MachineryEnum
  make: string
  model: string
  color: string
  year: string
  use: string
  purpose: string
  config: any
}

export interface ICreateMachineryInspection extends ICreateInspectionCommon {
  machinery: IMachinery
}

export enum MachineryPurpose {
  AGRICOLA = 'Agrícola',
  VIAL = 'Vial',
  INDUSTRIAL = 'Industrial',
}

export enum MachineryUse {
  OFICIAL = 'OFICIAL',
  PRIVADO = 'PRIVADO',
  PÚBLICO = 'PÚBLICO',
}
